import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LoggingService } from 'src/app/services/logging.service';
import { AppComponent } from '../../components/app/app.component';
import { SafeUrl } from '@angular/platform-browser';
import { TheNaviGator } from 'src/app/services/the-navi-gator.service';

@Component({
    templateUrl: './onboarding-completed.page.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OnboardingCompletedPage implements OnInit {
  url: SafeUrl = "";

  /**
   * 
   * @param navigate The navi Gator that replaces Router to send you to different pages/modules
   */
  constructor(private loggingService: LoggingService, public whiteLabelProvider: AppComponent,
    private navigate: TheNaviGator) {
    // Must not be empty. It's approved by a comment.
  }

  async ngOnInit() {
    this.url = "https://" + window.location.host.toLowerCase();
  }

  login() {
    this.navigate.To_Dashboard();
  }
}

